import { createContext } from 'react'

import { TransferListItem } from './types'

export type TransferListContextProps = {
  areAllChecked: (items: TransferListItem[]) => boolean
  checked: TransferListItem[]
  indeterminateChecked: (items: TransferListItem[]) => boolean
  isDisabled?: boolean
  numberOfChecked: (items: TransferListItem[]) => number
  select: (item: TransferListItem) => () => void
  selectAll: (items: TransferListItem[]) => () => void
}

export const TransferListContext = createContext<TransferListContextProps>(
  {} as TransferListContextProps,
)
